export default "__VITE_ASSET__Dm1vmf94__"